import { render } from "./configTable.vue?vue&type=template&id=7ababc3a&scoped=true"
import script from "./configTable.vue?vue&type=script&lang=js"
export * from "./configTable.vue?vue&type=script&lang=js"

import "./configTable.vue?vue&type=style&index=0&id=7ababc3a&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ababc3a"]])

export default __exports__